<template>

	<div class="card-footer comfy p-2">

        <el-row>

            <el-col :span="7">
                <el-button class="gtm-button" v-if="anterior && servicio.step != 3" @click="anteriorPaso"><i class="el-icon-back"></i></el-button>
                &nbsp;
            </el-col>

            <el-col :span="10" class="text-center">
                <b class="s-30 text-white precio ivy-bold" v-if="servicio.precio && paso > 0">${{ precioFormat }}</b>
                &nbsp;
            </el-col>

            <el-col :span="7" class="text-right">
                <el-button class="gtm-button" v-if="servicio.step != 3" :id="identificador" type="primary" :disabled="!siguiente" @click="siguientePaso"><i class="el-icon-right"></i></el-button>
            </el-col>

        </el-row>

    </div>

</template>

<style type="text/css">
    .el-button{
        padding: 10px;
    }
    .precio{
        line-height: 1.32em;
        font-weight: 600;
    }
    .gtm-button span{
        pointer-events: none;
    }
</style>

<script>
	export default {
        props: [
            'servicio',
            'cliente'
        ],
        data() {
            return {
                paso: 0,
                anterior: false,
                siguiente: false,
                precioNeto: ''
            }
        },
        computed: {
            precioFormat: function(){
                if(this.precioNeto){
                    this.servicio.precioFinal = this.precioNeto
                    return this.precioNeto.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                }
                this.servicio.precioFinal = this.servicio.precio
                return this.servicio.precio.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            identificador: function(){
                return 'click_paso_' + this.servicio.step
            }
        },
        watch: {
            'servicio.prev': function(val){
                this.anterior = this.servicio.prev
            },
            'servicio.next': function(val){
                this.siguiente = this.servicio.next
                // this.siguientePaso()
            },
            'servicio.step': function(val){
                this.paso = this.servicio.step
            },
            'servicio.busqueda': function(){
                if(!this.servicio.busqueda){
                    return
                }else if(!this.servicio.tipo){
                    return
                }else {
                    this.siguiente = true
                }
            },
            // 'servicio.precio': function(val){
            //     if(val){
            //         precioFormat()
            //     }
            // }
        },
        methods: {
            siguientePaso(){
                if (!this.cliente.opt_verified) {
                    // Opcional: mostrar un mensaje al usuario
                    // alert('Por favor, verifica tu información antes de continuar.');
                    console.log('User not verified, cannot proceed to next step');
                    return; // No permitir avanzar si opt_verified es falso
                }

                if(this.paso == 2){
                    this.siguiente = false
                }
                if(this.paso == 3){
                    alert('Ir a pago')
                    return
                }
                this.$emit('nextStep', this.paso + 1)
            },
            anteriorPaso(){
                if(this.paso == 1){
                    this.siguiente = false
                    EventBus.$emit('limpiarPasoDos')
                }else if(this.paso == 3){
                    this.siguiente = true
                }
                this.precioNeto = ''
                this.$emit('prevStep', this.paso)
            }
        },
        mounted() {
            // console.log('--- paso uno component mounted ---')
            EventBus.$on('changeSelectAddress', data => {
                this.siguiente = false
            })
            EventBus.$on('confirmarPasoDosFecha', data => {
                this.siguiente = false
                if(data){
                    this.siguiente = true
                }
            })
            EventBus.$on('confirmarPasoDosManual', data => {
                this.siguiente = false
                if(data == '1'){
                    this.siguiente = true
                }
            })
            EventBus.$on('actualizarPrecio', data => {
                this.precioNeto = data
            })
            EventBus.$on('bloquearSiguiente', data => {
                this.siguiente = data
            })
        }
    };
</script>